import _ from 'lodash';
import React, { useContext } from 'react';
import { BoardTheme } from '@fluentui/react-teams/lib/esm/components/Board/BoardTheme';
import {
  Box,
  SiteVariablesPrepared,
  ProviderConsumer as FluentUIThemeConsumer,
} from '@fluentui/react-northstar';
import MyWorkBoardView from './BoardView';
import { MyWorkContext } from '../MyWorkContextProvider';
import { RefreshBar } from '../../../shared/components/table/RefreshBar';
import useWindowWidth from '../../useWindowWidth';

interface WorkProps {
  [key: string]: any;
}

export interface IMyWorkBoardView {
  siteVariables: SiteVariablesPrepared;
}
export interface IMyWorkBoardViewTickets extends IMyWorkBoardView {
  tickets?: Ticket[];
}

export interface Element {
  title: string;
  template: JSX.Element | JSX.Element[];
  hidden?: boolean;
}

const MyWorkBoard = () => <MyWorkBoardTheme />;

export default MyWorkBoard;

const MyWorkBoardTheme: React.FC<WorkProps> = () => {
  const { myWorkStates } = useContext(MyWorkContext);
  // Refresh's loading bar lies across this box rather than the board inside it, so it runs edge to edge - the
  // board sits 10px in, and clips anything wider than itself.
  const isRefreshing = (myWorkStates.boardLanesRefreshing ?? 0) > 0;
  const isPhone = useWindowWidth() < 768;
  return (
  <FluentUIThemeConsumer
    render={(globalTheme) => {
      return (
        <BoardTheme globalTheme={globalTheme} style={{ height: '100%' }}>
          <Box
            variables={({ colorScheme }: SiteVariablesPrepared) => ({
              backgroundColor: colorScheme.default.background2,
            })}
            className={`h-full my-work-board-box`}
            style={{ padding: '0 10px 0 10px', marginTop: '-5px', position: 'relative' }}
          >
            {/* Flush under the toolbar (100px - this box starts at 99px, pulled up 5px), over its shadow and grey
                divider, and 3px as on My Work's list (measured). */}
            {isRefreshing && !isPhone && <RefreshBar board style={{ top: 1, height: 3 }} />}
            {/* On a phone the board is inside the page's scroll area (my-work-phone-body), which clipped the bar
                above to 1px at its top edge; there it sticks to the top of that area instead, so it stays in view
                however far the cards are scrolled - as on the ticket list. The negative margin spans the 10px
                padding. */}
            {isRefreshing && isPhone && <RefreshBar style={{ height: 3, marginBottom: -3, marginLeft: -10, marginRight: -10 }} />}
            <MyWorkBoardView
              key={'myworklist'}
              siteVariables={globalTheme.siteVariables}
            />
          </Box>
        </BoardTheme>
      );
    }}
  />
  );
};
